import { useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from "@albo-ui/core";
import { MenuItem, TextField, Select, InputLabel, FormControl } from "@mui/material";
import { useCustomerAdd } from "./hooks/useCustomerAdd";

export const CustomerVipAdd = ({ changeAlert, changeLoader, handleGet, onClose, open, title, catalog, type }: any) => {
    const { zPos, form, loading, isValidForm, phoneCode, onHandleChange, onHandlePhone, onHandleConfirm } = useCustomerAdd(open, changeAlert, type, handleGet, onClose);

    useEffect(() => {
        changeLoader(loading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open={open} onClose={onClose} style={{ display: zPos !== 45 ? "none" : null }}>
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 30 }}>
                <FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
                    <FlexGrid container spacing={2} fullWidth>
                        <TextField value={(form["customer"] && form["customer"]["uuid"]) || ""} onInput={onHandleChange.bind(this, "customer", "uuid")} label="UUID" color="secondary" fullWidth/>
                    </FlexGrid>
                    <FlexGrid container spacing={2} fullWidth>
                        <TextField value={(form["customer"] && form["customer"]["email"]) || ""} onInput={onHandleChange.bind(this, "customer", "email")} label="Correo" color="secondary" fullWidth/>
                        <TextField value={(form["customer"] && form["customer"]["taxid"]) || ""} onInput={onHandleChange.bind(this, "customer", "taxid")} label="RFC" color="secondary" fullWidth/>
                    </FlexGrid>
                    <FlexGrid container spacing={2} fullWidth>
                        <FormControl sx={{width: "55%"}}>
                            <InputLabel id="demo-simple-select-label">Código País</InputLabel>
                            <Select MenuProps={{style: {zIndex: 35001}}} label="Código País" sx={{height: "100%"}}
                                value={phoneCode} onChange={onHandlePhone.bind(this)} size="small" color="secondary">
                                    {catalog?.map((item, index) => (
                                        <MenuItem key={`country-${index}`} value={item.m[0].dial}>
                                            (+{item.m[0].dial}) {item.m[0].code2}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        <TextField value={(form["customer"] && form["customer"]["phone"]) || ""} onInput={onHandleChange.bind(this, "customer", "phone")} label="Teléfono" color="secondary" fullWidth/>
                    </FlexGrid>
                </FlexGrid>
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify="space-between" alignItems="space-between" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{ textAlign: "end" }}>
                        <Button onClick={() => onHandleConfirm()} disabled={isValidForm} size="normal">
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
